import React, { useState, createContext, useContext } from "react";

export type Route = "login" | "signup" | "reset-password";

type RouterContextType = {
  loc: Route;
  setLoc: (loc: Route) => void;
};
const RouterContext = createContext<RouterContextType | undefined>(undefined);

const RouterProvider: React.FC = ({ children }) => {
  const [loc, setLoc] = useState<Route>("login");

  return (
    <RouterContext.Provider value={{ loc, setLoc }}>
      {children}
    </RouterContext.Provider>
  );
};

const useRouter = (): RouterContextType => {
  const context = useContext(RouterContext);
  if (!context) {
    throw new Error("'useRouter' cannot be used outside of a RouterContext!");
  }
  return context;
};

export { RouterProvider, useRouter };
